module.exports = __webpack_public_path__ + "fonts/merriweather-regular-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Merriweather/merriweather-regular-webfont.ttf
// module id = 3436
// module chunks = 0